












































import Vue from "vue"
import http from "../../plugins/http";
import { Menu } from "../../modules/Menu";
import * as Common from "../../commons/common";

export type DataType = {
  errors: string[]
  loginId: string
  password: string
};

export default Vue.extend({
  name: "SignIn",
  data(): DataType {
    return {
      errors: [],
      loginId: "",
      password: "",
    };
  },
  mounted() {
    this.$store.commit("setIsHeaderDisp", false);
    document.body.style.background = "whitesmoke";
  },
  beforeDestroy() {
    this.$store.commit("setIsHeaderDisp", true);
    document.body.style.background = "white";
  },
  methods: {
    // ログインボタン押下
    onSubmit(){
      this.errors = [];
      if(this.loginId.length == 0){
        this.errors.push("ログインIDを入力してください。");
        return;
      }

      if(this.password.length == 0){
        this.errors.push("パスワードを入力してください。");
        return;
      }
      
      http.post("/api/login", {condition: {login_id: this.loginId, password: this.password}})
        .then(response => {
          if (response.data.confirm == null) {
            this.executeLogin(response)
          }else {
            if(window.confirm('現在、ログイン中のユーザの処理が中断されます。本当によろしいですか？')){
              http.post("/api/login", {condition: {login_id: this.loginId, password: this.password}, confirmed: true})
                .then(response => {
                  this.executeLogin(response)
                })
                .catch(error => {
                  if (error.response.status == 401) {
                    this.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
                  }
                  if (error.response.status == 402) {
                    this.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
                  }
                  if (error.response.status == 403) {
                    this.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
                  }
                  if (error.response.status == 405) {
                    this.errors.push("同時にログインできる人数が上限に達しています。");
                  }
                })
            }
          }
        })
        .catch(error=>{
          if (error.response.status == 401) {
            this.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
          }
          if (error.response.status == 402) {
            this.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
          }
          if (error.response.status == 403) {
            this.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
          }
          if (error.response.status == 405) {
            this.errors.push("同時にログインできる人数が上限に達しています。");
          }
          if (error.response.status == 406) {
            this.errors.push("現在メンテナンス中のためログインできません。");
          }
          if (error.response.status == 409) {
            this.errors.push("アカウントが無効になっているためログインできません。");
          }
        });
    },
    // ログイン成功後の後処理
    executeLogin(response: any){
      
      // トークン設定
      var token = response.data.user.access_token
      document.cookie = 'access_token=' + token;
      document.cookie = 'smarky_user_id=' + response.data.user.id;

      this.$store.commit("setCurrentUser", response.data.user);
      this.$store.commit("setCurriculums", response.data.curriculums);
      this.$store.commit("setRooms", response.data.rooms);
      this.$store.commit("setEvents", response.data.events);

      if(response.data.user.login_count == 1) {
        this.$router.push(`/teacher_site/user_edit`).catch(err => {});
      } else {
        this.$router.push('/teacher_site/sheet_list').catch(err => {});
      }
    }
  }
})
